import { Link, useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleUp, faBars, faX } from '@fortawesome/free-solid-svg-icons';

import {goToLocation, fnDrawerMenu } from 'assets/js/commonUtil';
import { useEffect, useState } from "react";

import {pageMenuTabList01, pageMenuTabList02, pageMenuTabList03, pageMenuTabList04, pageMenuTabList05, pageMenuTabList06} from 'types/common';

export default function Header() {

  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [isFix, setIsFix] = useState(false);

  const handleMovePage = ({ item }: { item: { url: string; type: string } }) => {
    navigate(`${item.url}`, {
      state: {
        type: `${item.type}`,
      },
    });
  };

  async function fetchData() {
    if(pathname == "/"){
      setIsFix(true);
    }else{
      setIsFix(false);
    }
  }
  
  useEffect(() => {  
    fnDrawerMenu();
    fetchData();
  }, []);

  return (
    <>
      <div className="top-section fix">
        <div className="top-menu-bg"></div>
        <div className="top-menu">
          <div className="item logo"><Link to='/'><div id="top_logo" className="img-logo img-logo40"></div></Link></div>
          <div className="item"></div>
          <div className="item title">회사소개</div>
          <div className="item title">OEM • ODM</div>
          <div className="item title">해외사업</div>
          <div className="item title">연구개발/품질관리</div>
          <div className="item title">브랜드/채널소개</div>
          <div className="item title">천호소식</div>
          <div className="item title"></div>
          <div className="btn-drawer">
            <FontAwesomeIcon icon={faBars} className='drawer-menu-trigger'/>
          </div>

          <div className="item empty"></div>
          <div className="item empty"></div>
          <div className="item send-row">
            <div className="sub-menu">
              {pageMenuTabList01.map((item, idx) => (
                <div className="sub-item" key={idx} onClick={() => goToLocation(item.url)}>{item.text}</div>
              ))}
            </div>
          </div>
          <div className="item send-row">
            <div className="sub-menu">
              {pageMenuTabList02.map((item, idx) => (
                <div className="sub-item" key={idx} onClick={() => goToLocation(item.url)}>{item.text}</div>
              ))}
            </div>
          </div>
          <div className="item send-row">
            <div className="sub-menu">
              {pageMenuTabList03.map((item, idx) => (
                <div className="sub-item" key={idx} onClick={() => goToLocation(item.url)}>{item.text}</div>
              ))}
            </div>
          </div>
          <div className="item send-row">
            <div className="sub-menu">
              {pageMenuTabList04.map((item, idx) => (
                <div className="sub-item" key={idx} onClick={() => goToLocation(item.url)}>{item.text}</div>  
              ))}
            </div>
          </div>
          <div className="item send-row">
            <div className="sub-menu">
              {pageMenuTabList05.map((item, idx) => (
                <div className="sub-item" key={idx} onClick={() => goToLocation(item.url)}>{item.text}</div>  
              ))}
            </div>
          </div>
          <div className="item send-row">
            <div className="sub-menu">
              {pageMenuTabList06.map((item, idx) => (
                <div className="sub-item" key={idx} onClick={() => goToLocation(item.url)}>{item.text}</div>  
              ))}
            </div>
          </div>
          <div className="item"></div>
        </div>
      </div>
      <div id="drawer-menu" className="wrap" >
        <div className="drawer-menu-list">
          <div className="item">
            <div className="item-home" onClick={() => goToLocation('/')}>HOME</div>           
          </div>
          <div className="item">
            <div className="item-title">회사소개 <span className="item-ext-Down on"><FontAwesomeIcon icon={faAngleDown} /></span><span className="item-ext-Up"><FontAwesomeIcon icon={faAngleUp} /></span></div>
            <div className="sub-menu">
              {pageMenuTabList01.map((item, idx) => (
                <div className="sub-item" key={idx} onClick={() => goToLocation(item.url)}>{item.text}</div>  
              ))}
            </div>
          </div>
          <div className="item">
            <div className="item-title">OEM • ODM <span className="item-ext-Down on"><FontAwesomeIcon icon={faAngleDown} /></span><span className="item-ext-Up"><FontAwesomeIcon icon={faAngleUp} /></span></div>
            <div className="sub-menu">
              {pageMenuTabList02.map((item, idx) => (
                <div className="sub-item" key={idx} onClick={() => goToLocation(item.url)}>{item.text}</div>  
              ))}
            </div>
          </div>
          <div className="item">
            <div className="item-title">해외사업 <span className="item-ext-Down on"><FontAwesomeIcon icon={faAngleDown} /></span><span className="item-ext-Up"><FontAwesomeIcon icon={faAngleUp} /></span></div>
            <div className="sub-menu">
              {pageMenuTabList03.map((item, idx) => (
                <div className="sub-item" key={idx} onClick={() => goToLocation(item.url)}>{item.text}</div>  
              ))}
            </div>
          </div>
          <div className="item">
            <div className="item-title">연구개발/품질관리 <span className="item-ext-Down on"><FontAwesomeIcon icon={faAngleDown} /></span><span className="item-ext-Up"><FontAwesomeIcon icon={faAngleUp} /></span></div>
            <div className="sub-menu">
              {pageMenuTabList04.map((item, idx) => (
                <div className="sub-item" key={idx} onClick={() => goToLocation(item.url)}>{item.text}</div>  
              ))}
            </div>
          </div>
          <div className="item">
            <div className="item-title">브랜드/채널소개 <span className="item-ext-Down on"><FontAwesomeIcon icon={faAngleDown} /></span><span className="item-ext-Up"><FontAwesomeIcon icon={faAngleUp} /></span></div>
            <div className="sub-menu">
              {pageMenuTabList05.map((item, idx) => (
                <div className="sub-item" key={idx} onClick={() => goToLocation(item.url)}>{item.text}</div>  
              ))}
            </div>
          </div>
          <div className="item">
            <div className="item-title">천호소식 <span className="item-ext-Down on"><FontAwesomeIcon icon={faAngleDown} /></span><span className="item-ext-Up"><FontAwesomeIcon icon={faAngleUp} /></span></div>
            <div className="sub-menu">
              {pageMenuTabList06.map((item, idx) => (
                <div className="sub-item" key={idx} onClick={() => goToLocation(item.url)}>{item.text}</div>  
              ))}
            </div>
          </div>
          <div className="btn-bottom">
            <div className="btn01" onClick={() => goToLocation("/partners")}>기업 포트폴리오</div>
            <div className="btn02" onClick={() => goToLocation("/proposal")}>OEM/ODM 문의</div>
          </div>
        </div>
        <div className='drawer-menu-close'><FontAwesomeIcon icon={faX} /></div>
      </div>
    </>
  );
}